// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { getSessionUserEmail } from '../config/common';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../hooks';
import * as profileAction from '../Action/Profile/Profile_Action';
import Loader from './Loader';
import TicketTab from './TicketTab';
import ChangeRequestTab from './ChangeRequestTab';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { hasRole } from '../utils/roles';

/** Sidenav opens Support Tickets and Change requests as separate routes; `view` selects which list/detail UI to show. */
const GetSupport = ({ roles, view }) => {
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const id = searchParams.get("id");
    const tab = searchParams.get("tab");
    const [userDetails, setUserDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const hasFetched = useRef();
    const [navKey, setNavKey] = useState(0);

    const basePath = view === 'changeRequests' ? '/change-requests' : '/support-tickets';

    const navigateToItem = (targetTab, targetId) => {
        setNavKey((k) => k + 1);
        const path = targetTab === 'changeRequest' ? '/change-requests' : '/support-tickets';
        const params = new URLSearchParams();
        if (targetId) params.set('id', targetId);
        const q = params.toString();
        navigate(q ? `${path}?${q}` : path, { replace: false });
    };

    const clearDetailParams = () => {
        navigate(basePath, { replace: true });
    };

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;

        /**
         * Support admins: tabs fetch their own data and show the shared full-screen <Loader /> once.
         * Do not stack a second loader here (profile fetch) before TicketTab/ChangeRequestTab mounts.
         * Non-support users need profile first for support-contacts UI — keep one loader for that path.
         */
        if (hasRole(roles, "support")) {
            getUserDetails();
            return;
        }
        setIsLoading(true);
        getUserDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getUserDetails = () => {
        const param = { email: getSessionUserEmail() };
        dispatch(profileAction.profile({ data: JSON.stringify(param) })).then((response) => {
            setIsLoading(false);
            if (response.status !== 1) {
                toast.error(response.message);
                return;
            }
            setUserDetails(response.data);
        }).catch((error) => {
            setIsLoading(false);
            toast.error(error.message);
        });
    };

    return (
        <>
            {isLoading && <Loader />}

            <div className="container-fluid mx-auto py-3 px-3 px-md-4 copilot-get-support-page">
                {!hasRole(roles, 'support') ? (
                    <>
                        <header className="mb-3">
                            <h2 className="copilot-changelog-section-title mb-1">Support access</h2>
                            <p className="copilot-changelog-section-lead mb-0">
                                Connect with a Support Admin user to access tickets and change requests.
                            </p>
                        </header>
                        <div className="mb-2">
                            <p className="copilot-changelog-detail-section-title mb-2">Support contacts</p>
                            {userDetails.supportContacts && userDetails.supportContacts.length > 0 ? (
                                <ul className="list-unstyled copilot-profile-contact-list mb-0">
                                    {userDetails.supportContacts.map((item, index) => (
                                        <li key={index} className="copilot-profile-contact-item">
                                            <span className="fw-semibold">{item.Name}</span>
                                            {item.Email ? (
                                                <span className="text-body-secondary ms-2 small">({item.Email})</span>
                                            ) : null}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="small text-body-secondary mb-0">No support contacts available.</p>
                            )}
                        </div>
                    </>
                ) : view === 'changeRequests' ? (
                    <ChangeRequestTab
                        id={id}
                        navKey={navKey}
                        tab="changeRequest"
                        onNavigate={navigateToItem}
                        onCloseDetail={clearDetailParams}
                    />
                ) : (
                    <TicketTab
                        id={id}
                        navKey={navKey}
                        tab={tab || 'ticket'}
                        onNavigate={navigateToItem}
                        onCloseDetail={clearDetailParams}
                    />
                )}
            </div>
        </>

    )
}

export default GetSupport;